import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DisplayBox, Loading } from "../components";
import { ApiHelper, ArrayHelper, DateHelper, EnvironmentHelper, FeedInterface, SubscriptionInterface } from "../helpers";


interface Props {

}


export const FeedsPage: React.FC<Props> = props => {

  const [feeds, setFeeds] = React.useState<FeedInterface[]>(null);
  const [subscriptions, setSubscriptions] = React.useState<SubscriptionInterface[]>(null);


  const getFeeds = () => {
    const result: React.ReactElement[] = [];
    feeds?.forEach(f => {
      const thumbPath = EnvironmentHelper.ContentRoot + "/feeds/" + f.id + "/thumb.png?modified=" + DateHelper.convertToDate(f.lastModified).getTime();
      result.push(<Col sm={6} md={4} xl={3}>
        <Link to={"/settings/feeds/" + f.id}>
          <img src={thumbPath} alt="thumbnail" />
          <span>{f.name}</span>
        </Link>
      </Col>);
    });
    return (<div id="designerList" className="row condensed">{result}</div>);
  }

  const getSubscriptions = () => {
    const result: React.ReactElement[] = [];
    if (feeds && subscriptions) {
      subscriptions.forEach(s => {
        const f = ArrayHelper.getOne(feeds, "id", s.feedId);
        if (f) result.push(<li><Link to={"/settings/feeds/" + f.id}><span>{f.name}</span></Link></li>);
      });
      return (<ul>{result}</ul>);
    }
  }



  const init = () => {
    ApiHelper.get("/feeds/public").then((data) => { setFeeds(data); });
    ApiHelper.get("/subscriptions").then((data) => { setSubscriptions(data); });
  }

  React.useEffect(init, [])

  if (feeds === null) return <Loading />
  return (
    <>
      <h1><i className="fas fa-satellite-dish"></i> Feeds</h1>
      <Row>
        <Col md={8}>{getFeeds()}</Col>
        <Col md={4}>
          <DisplayBox headerIcon="fas fa-satellite-dish" headerText="My Subscriptions">
            {getSubscriptions()}
          </DisplayBox>
        </Col>
      </Row>
    </>
  );
};